












































import { Component, Vue, Prop, Inject } from 'vue-property-decorator'
import { toNumber, toString } from 'lodash'
import { DiscountsMixin } from '@shared/mixins/discounts'
import { getSelectedCityId, toV, searchToWhereUrl } from '@/app/core/utils'
import { namespace } from 'vuex-class'
import { NEW_SIGN_YS_ID } from '@/app/core/constant'
import { ShopTypes } from '../../config'
import iconUserGold from '@/assets/images/search/icon-user_gold.png'
import iconUserPregnant from '@/assets/images/search/icon-user_pregnant.png'
import iconUserCertify from '@/assets/images/search/icon-user_certify.png'

const shopHomeModule = namespace('shopHome')

//const Img_ycyx = require('../../assets/image/ycyx.png')

interface IItem {
  spuName: string
  cmmdtyImage: string
  maxPrice: string | number
  minPrice: string | number
  saleNum: string | number
  spuId: string
  skuId: string | number
  source: string | number
  level4CategoryId?: string | number
  templateType2Id?: string | number
  businessId?: string
  photoItem?: string
  customerType?: number
  customerPrice?: number | null
}

@Component
export default class ServiceItem extends DiscountsMixin {
  @Inject({ default: null })
  viewCmmdTrackParams!: any

  @Prop({ default: [] }) readonly item!: IItem
  @shopHomeModule.State shopDetail!: any
  @shopHomeModule.State shopType!: ShopTypes

  readonly Ticket: ShopTypes = ShopTypes.Ticket

  //Img_ycyx = Img_ycyx

  get showDiscounts() {
    const item: any = this.item
    const hasDis = item && (item.promotionName || item.couponName)
    return !!hasDis
  }

  get imgTally() {
    const item: any = this.item
    return item.isSpec == 1 ? '孕产U选' : this.seekCommodityPromotion(item, 1)
  }

  get spuUserTag() {
    if (this.item.customerType == 1) {
      return iconUserGold
    } else if (this.item.customerType == 2) {
      return iconUserPregnant
    } else if (this.item.customerType == 3) {
      return iconUserCertify
    }
    return ''
  }

  toDetail() {
    const cityCode = getSelectedCityId()
    this.viewCmmdTrackParams && this.$newClickTracker(this.viewCmmdTrackParams)
    // const { seckill } = this.seekPromotion(this.item)
    // const query: any = seckill ? { skuId: seckill.skuId, ruleId: seckill.ruleId, ruleType: 3 } : {}
    const { level4CategoryId = '' } = this.item
    if (level4CategoryId.toString() === NEW_SIGN_YS_ID) {
      location.href = `//life.cekid.com/y/ysList?swt=1&cityCode=${cityCode}`
      return
    }
    // toV({
    //   name: 'product-detail',
    //   params: { spuId: this.item.spuId },
    //   query: { refresh: 'no', businessId: this.shopDetail.businessKey }
    // })
    location.href = searchToWhereUrl({ spuType: toNumber(this.item.templateType2Id), spuId: this.item.spuId, businessId: this.item.businessId, module: 7 })
  }

  get getPrice() {
    const item = this.item
    return item.customerPrice != null ? item.customerPrice : item.minPrice
  }
}
